export const DISCLAIMER_TEXTS = {
  linkSecurityCheck: {
    text: '*A Serasa Experian não tem qualquer responsabilidade pelo conteúdo desta ferramenta ou pelas consequências de quaisquer ações tomadas com base nas informações fornecidas pela PSAFE TECNOLOGIA LTDA.',
    accessibleText:
      'Atenção!!! A Serasa Experian não tem qualquer responsabilidade pelo conteúdo desta ferramenta ou pelas consequências de quaisquer ações tomadas com base nas informações fornecidas pela empresa parceira PSAFE TECNOLOGIA LTDA',
  },
  documentConsulting: {
    text: '*Os serviços de consulta ao CPF e CNPJ são limitados a duas consultas gratuitas por CPF cadastrado, durante o período da presente ação, de 17/11/2022 a 30/11/2022. Após as duas consultas, será cobrado o valor normal do VocêConsulta.',
    accessibleText:
      'Atenção!!! Os serviços de consulta ao CPF e CNPJ são limitados a duas consultas gratuitas por CPF cadastrado, durante o período da presente ação, de 17 de novembro de 2022 a 30 de novembro de 2022. Após as duas consultas, será cobrado o valor normal do VocêConsulta',
  },
  consultationReport: {
    text: '*O serviço de relatório de consulta ao CPF está disponível gratuitamente durante o período da presente ação, de 17/11/2022 a 30/11/2022.',
    accessibleText:
      'Atenção!!! O serviço de relatório de consulta ao CPF está disponível gratuitamente durante o período da presente ação, de 17 de novembro de 2022 a 30 de novembro de 2022',
  },
  darkWebConsulting: {
    text: '*O serviço de consulta a vazamentos de dados na Dark Web está disponível gratuitamente, limitada a 1 por CPF.',
    accessibleText:
      'Atenção!!! O serviço de consulta a vazamentos de dados na Dark Web está disponível gratuitamente, limitada a uma consulta por CPF.',
  },
}
